import type { SigninRedirectArgs } from 'oidc-client-ts';
import type React from 'react';
import { useEffect, useState } from 'react';
import { hasAuthParams, useAuth } from 'react-oidc-context';

import ErrorPage from '@/pages/error';
import LoadingPage from '@/pages/loading';

const AutoSignin = ({
  args,
  errorComponent: ErrorComponent = ErrorPage,
  loadingComponent: LoadingComponent = LoadingPage,
  onBeforeSignin,
}: {
  args?: SigninRedirectArgs;
  errorComponent?: React.ComponentType<React.PropsWithChildren>;
  loadingComponent?: React.ComponentType;
  onBeforeSignin?: () => Promise<void> | void;
}) => {
  const auth = useAuth();
  const [hasTriedSignin, setHasTriedSignin] = useState(false);

  useEffect(() => {
    (async () => {
      if (!hasAuthParams() && !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading && !hasTriedSignin) {
        await onBeforeSignin?.();
        auth.signinRedirect(args);
        setHasTriedSignin(true);
      }
    })();
  }, [args, auth, hasTriedSignin, onBeforeSignin]);

  if (auth.error) return <ErrorComponent>{auth.error.message}</ErrorComponent>;
  if (auth.isLoading) return <LoadingComponent />;

  return null;
};
AutoSignin.displayName = 'AutoSignin';

export default AutoSignin;
